import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@shared/ui/dialog";
import { Clock, History } from "lucide-react";
import { Button } from "@shared/ui/button";
import { TimelineTab } from "@features/cx/shared/components/tabs/TimelineTab";

interface AuditTrailModalProps {
  title: string;
  remoteUtilityId?: any;
  entityId?: string;
  actionType?: string;
}

export const AuditTrailModal = ({ title, remoteUtilityId, entityId, actionType }: AuditTrailModalProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="text-gray-600 gap-2">
          <History className="w-4 h-4" /> Activity Log
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] flex flex-col overflow-hidden p-0 gap-0">
        <DialogHeader className="px-6 py-4 border-b border-gray-100 shrink-0">
          <DialogTitle className="flex items-center gap-2 text-xl text-gray-900">
            <Clock className="w-5 h-5 text-blue-600" /> Activity Log— {title}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto p-6 space-y-4 bg-gray-50/50">
          <TimelineTab 
            remoteUtilityId={remoteUtilityId} 
            entityId={entityId || "0"} 
            actionType={actionType || "BRANDING_UPDATE"} 
          />
        </div>
        <div className="p-4 text-center text-xs text-gray-500 border-t border-gray-100 shrink-0 bg-white shadow-[0_-10px_15px_-3px_rgba(0,0,0,0.05)] relative z-10">
          Showing the most recent changes.
        </div>
      </DialogContent>
    </Dialog>
  );
};
